"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Views for the Concur expense report tools (list, detail, exceptions). Merged
 * into `concurToolRegistry` by the registry wiring.
 */
export const concurReportToolRegistry = {
  concurListReports: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./report-views").then(({ ConcurListReportsToolView }) => ({
        default: ConcurListReportsToolView,
      }))
    ),
  },
  concurGetReport: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./report-views").then(({ ConcurGetReportToolView }) => ({
        default: ConcurGetReportToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
